import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { carouselImageSet } from "../../assets/images/castsImages/carousel";
import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
import NormalRotate from "./HomeScreenSample.tsx/NormalRotate";

const Home = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);

  const title = useFadeInScroll<HTMLDivElement>();
  const body = useFadeInScroll<HTMLParagraphElement>();
  const actions = useFadeInScroll<HTMLDivElement>();

  /* Desktop detection */
  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 1280);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  /* Carousel auto play */
  useEffect(() => {
  let interval: number | undefined;

  const startCarousel = () => {
    if (interval !== undefined) {
      window.clearInterval(interval);
    }

    interval = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % carouselImageSet.length);
    }, 5200);
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      if (interval !== undefined) {
        window.clearInterval(interval);
        interval = undefined;
      }
    } else {
      startCarousel();
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);

  startCarousel();

  return () => {
    if (interval !== undefined) {
      window.clearInterval(interval);
    }

    document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [carouselImageSet.length]);;;

  /* Parallax only on desktop */
  useEffect(() => {
    if (!isDesktop) return;
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isDesktop]);

  return (
    <>
    <NormalRotate/>
    {/* <CentreGravityEffect/>
    <CentreOrbital/>
    <ParticleLayer/> */}
    </>
  );
};

export default Home;